import { CURRENT_SERVER } from '@/constants/domains'
import VueCookie from 'vue-cookie'
const axios = require('axios')

export default {
  getTags: function ({page = 1, limit = 999, search, sort}) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    const query = [`page=${page}`, `limit=${limit}`]
    if (sort) query.push(`sort[]=${sort}`)
    if (search) query.push(`search=${search}`)
    const route = search ? 'tags' : 'tags/withoutelastic'
    return instCred.get(route + '?' + query.join('&'))
  },
  createTag: function (tag) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.post('tags/', tag)
  },
  updateTag: function (tag) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.put('tags/' + tag.id, tag)
  },
  deleteTag: function (tagId) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.delete('tags/' + tagId)
  }
}



// WEBPACK FOOTER //
// ./src/api/Tags/api.js